import {TimeSpan} from "@sparkware/app-utils";

export default class StopWatch {

    private _start: number = 0;
    private _elapsed: number = 0;

    constructor(autoStart = false) {
        if (autoStart) {
            this.start();
        }
    }

    start() {
        this._start = new Date().getTime();
        this._elapsed = 0;
    }

    stop(): TimeSpan {
        const end = new Date().getTime();
        this._elapsed = end - this._start;
        this._start = 0;
        return this.getElapsedTime();
    }

    // two scenarios: 
    // 1. start(); stop(); then getElapsedTime() -> will return stored elapsed value
    // 2. start(); getElapsedTime(); <after some time...> getElapsedTime(); -> will return ad-hoc value
    getElapsedTime(): TimeSpan {

        if (this._start === 0) {
            // normal use case, when we called stop() before
            return TimeSpan.fromMilliseconds(this._elapsed);
        }

        // if we forgot to call stop() or we want to use same stop watch for multiple operations we can on the fly getElapsedTime
        const end = new Date().getTime();
        const elapsed = end - this._start;
        return TimeSpan.fromMilliseconds(elapsed);
    }
}
